import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import { t } from 'ember-intl';
import { FocusScreen } from 'frontend-utils';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-footer';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-header';
import type HotelSettingsCompetitorsBenchmarkSmartCompsetValidationController from 'lumen/controllers/hotel/settings/competitors/benchmark/smart-compset/validation';
import importAsset from 'lumen/helpers/import-asset';
import lottieAnimation from 'lumen/modifiers/lottie-animation';

interface HotelSettingsCompetitorsBenchmarkSmartCompsetValidationSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkSmartCompsetValidationController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{true}}
    @isCancelDisabled={{true}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
    @size="large"
  >
    <:header>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader
        @currentStep={{3}}
      />
    </:header>

    <:body>
      <div class="smart-compset__builder__body">
        <div class="smart-compset__builder__body__validation">
          <div
            {{lottieAnimation
              (importAsset
                "animations/benchmark-insight/smart-compset-builder-validation.json"
              )
              true
            }}
          />

          <div class="smart-compset__builder__body__validation__labels">
            <p class="heading-3">
              {{t
                "benchmark-insight.smart-compset.smart-compset-builder.title.validation"
              }}
            </p>
            <p
              class="smart-compset__builder__body__validation__labels__sublabel text-300--regular mt-1"
            >
              {{t
                "benchmark-insight.smart-compset.smart-compset-builder.sub-title.validation"
                chainName=@controller.chainName
              }}{{@controller.dots}}
            </p>
          </div>
        </div>
      </div>
    </:body>

    <:footer>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter
      >
        <span class="smart-compset__builder__footer--back">
          <PrismButton
            @buttonType="ghost"
            @iconBefore="arrow-left"
            @isDisabled={{true}}
            @label={{t "general.back"}}
          />
        </span>

        <span class="smart-compset__builder__footer--continue">
          <PrismButton
            @buttonType="brand"
            @isDisabled={{true}}
            @label={{t "general.continue"}}
          />
        </span>
      </HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter>
    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkSmartCompsetValidationSignature>;
